import { Card, CardBody, CardImg, CardTitle } from 'reactstrap';
import LoadingSpiner from '../components/LoadingSpiner';

import comImg from './../../assets/images/passer-la-commande.png';
import rechargeImg from './../../assets/images/recharge.png';
import carImg from './../../assets/images/car.png';
import { useDashboardStats } from '../../Api/queriesDashboard';
import { useNavigate } from 'react-router-dom';

const TotalCommande = () => {
  const {
    data: stats,
    isLoading: statsLoading,
    error: statsError,
  } = useDashboardStats();
  const navigate = useNavigate();

  const handleNavigate = () => {
    return navigate('/commandes');
  };

  return (
    <div onClick={() => handleNavigate()} style={{ cursor: 'pointer' }}>
      {statsLoading && <LoadingSpiner />}
      {!statsError && !statsLoading && (
        <Card
          style={{
            height: '180px',
            boxShadow: '1px 0px 10px rgba(1, 186, 186, 0.57)',
          }}
        >
          <CardImg
            src={comImg}
            alt='Commandes'
            style={{ height: '90px', objectFit: 'contain' }}
          />
          <CardBody>
            <CardTitle className='text-center'>
              <span className='text-info fs-5'>
                {stats?.commandes?.total ?? 0}
              </span>
              <p>Commandes Enregistrées</p>
            </CardTitle>
          </CardBody>
        </Card>
      )}
    </div>
  );
};
const TotalCommandeNotDelivred = () => {
  const {
    data: stats,
    isLoading: statsLoading,
    error: statsError,
  } = useDashboardStats();
  const navigate = useNavigate();

  const handleNavigate = () => {
    return navigate('/commandes');
  };

  return (
    <div onClick={() => handleNavigate()} style={{ cursor: 'pointer' }}>
      {statsLoading && <LoadingSpiner />}
      {!statsError && !statsLoading && (
        <Card
          className='d-flex flex-column align-items-center justify-content-center'
          style={{
            height: '180px',
            boxShadow: '1px 0px 10px rgba(1, 186, 186, 0.57)',
          }}
        >
          <CardImg
            src={rechargeImg}
            alt='Commandes'
            style={{ height: '110px', objectFit: 'contain' }}
          />
          <CardBody>
            <CardTitle className='text-center'>
              <span className='text-danger fs-5'>
                {stats?.commandes?.enAttente ?? 0}
              </span>
              <p>Commandes Non Livrés</p>
            </CardTitle>
          </CardBody>
        </Card>
      )}
    </div>
  );
};
const TotalCommandeToDelivre = () => {
  const {
    data: stats,
    isLoading: statsLoading,
    error: statsError,
  } = useDashboardStats();
  const navigate = useNavigate();

  const handleNavigate = () => {
    return navigate('/commandes');
  };

  return (
    <div onClick={() => handleNavigate()} style={{ cursor: 'pointer' }}>
      {statsLoading && <LoadingSpiner />}
      {!statsError && !statsLoading && (
        <Card
          className='d-flex flex-column align-items-center justify-content-center'
          style={{
            height: '180px',
            boxShadow: '1px 0px 10px rgba(1, 186, 186, 0.57)',
          }}
        >
          <CardImg
            src={carImg}
            alt='Commandes'
            style={{ height: '110px', objectFit: 'cover' }}
          />
          <CardBody>
            <CardTitle className='text-center'>
              <span className='text-warning fs-5'>
                {stats?.commandes?.enCours ?? 0}
              </span>
              <p>Commandes En Cours</p>
            </CardTitle>
          </CardBody>
        </Card>
      )}
    </div>
  );
};

export { TotalCommande, TotalCommandeNotDelivred, TotalCommandeToDelivre };
